import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';
import RelatedBlogPosts from '../../../components/feature/RelatedBlogPosts';

export default function FireAlarmSystemsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    
    // SEO Meta Tags
    document.title = "Yangın Alarm Sistemleri Kurulumu İstanbul | TSE Onaylı Yangın Güvenliği";
    
    // Meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'İstanbul, Kocaeli, Gebze, Tuzla ve Bursa\'da TSE onaylı yangın alarm sistemleri kurulumu. Duman dedektörleri, ısı sensörleri, sesli uyarı cihazları ve otomatik ihbar sistemi ile 7/24 yangın güvenliği.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'İstanbul, Kocaeli, Gebze, Tuzla ve Bursa\'da TSE onaylı yangın alarm sistemleri kurulumu. Duman dedektörleri, ısı sensörleri, sesli uyarı cihazları ve otomatik ihbar sistemi ile 7/24 yangın güvenliği.';
      document.head.appendChild(meta);
    }

    // Keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'yangın alarm sistemi, TSE onaylı yangın sistemi, duman dedektörü, ısı sensörü, yangın güvenliği kurulumu');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'keywords';
      meta.content = 'yangın alarm sistemi, TSE onaylı yangın sistemi, duman dedektörü, ısı sensörü, yangın güvenliği kurulumu';
      document.head.appendChild(meta);
    }

    // Open Graph Tags
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', 'Yangın Alarm Sistemleri Kurulumu İstanbul | TSE Onaylı Yangın Güvenliği');
    } else {
      const meta = document.createElement('meta');
      meta.setAttribute('property', 'og:title');
      meta.content = 'Yangın Alarm Sistemleri Kurulumu İstanbul | TSE Onaylı Yangın Güvenliği';
      document.head.appendChild(meta);
    }

    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', 'Fabrika ve sanayi tesisleri için yönetmeliğe uygun TSE onaylı yangın alarm sistemleri. Erken uyarı, otomatik ihbar ve acil durum yönetimi.');
    } else {
      const meta = document.createElement('meta');
      meta.setAttribute('property', 'og:description');
      meta.content = 'Fabrika ve sanayi tesisleri için yönetmeliğe uygun TSE onaylı yangın alarm sistemleri. Erken uyarı, otomatik ihbar ve acil durum yönetimi.';
      document.head.appendChild(meta);
    }

    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) {
      ogUrl.setAttribute('content', 'https://fiberek.com/guvenlik-sistemleri/yangin-alarm-sistemleri');
    } else {
      const meta = document.createElement('meta');
      meta.setAttribute('property', 'og:url');
      meta.content = 'https://fiberek.com/guvenlik-sistemleri/yangin-alarm-sistemleri';
      document.head.appendChild(meta);
    }

    // Canonical URL
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', 'https://fiberek.com/guvenlik-sistemleri/yangin-alarm-sistemleri');
    } else {
      const link = document.createElement('link');
      link.rel = 'canonical';
      link.href = 'https://fiberek.com/guvenlik-sistemleri/yangin-alarm-sistemleri';
      document.head.appendChild(link);
    }

    // Cleanup function
    return () => {
      document.title = 'Fiber Ek';
    };
  }, []);

  const features = [
    { icon: 'ri-temp-hot-line', title: 'Isı Dedektörleri', description: 'Hızlı sıcaklık artışı algılama' },
    { icon: 'ri-mist-line', title: 'Duman Dedektörleri', description: 'Erken duman tespiti' },
    { icon: 'ri-volume-up-line', title: 'Sesli Uyarı', description: 'Yüksek desibel alarm sireni' },
    { icon: 'ri-flashlight-line', title: 'Işıklı Uyarı', description: 'Görsel alarm sinyali' },
    { icon: 'ri-phone-line', title: 'Otomatik İhbar', description: 'İtfaiye ve yetkililere bildirim' },
    { icon: 'ri-shield-check-line', title: 'TSE Onaylı', description: 'Yönetmeliğe uygun sistem' }
  ];

  const detectorTypes = [
    {
      title: 'Optik Duman Dedektörleri',
      description: 'Işık saçılımı prensibi ile duman algılama. Erken uyarı sağlar, yavaş yanan yangınlarda etkilidir. Fabrika, ofis ve kapalı alanlarda kullanılır.',
      applications: ['Ofis alanları', 'Koridorlar', 'Toplantı salonları', 'Depo alanları']
    },
    {
      title: 'İyonizasyon Duman Dedektörleri',
      description: 'Hızlı yanan yangınları erken tespit eder. Küçük duman partikülleri algılar. Endüstriyel alanlarda tercih edilir.',
      applications: ['Üretim hatları', 'Makine parkları', 'Elektrik odaları', 'Teknik alanlar']
    },
    {
      title: 'Sabit Sıcaklık Dedektörleri',
      description: 'Belirli sıcaklık eşiğine ulaşıldığında alarm verir. Mutfak, kazan dairesi gibi yüksek sıcaklık olan alanlarda kullanılır.',
      applications: ['Mutfaklar', 'Kazan daireleri', 'Sıcak işlem alanları', 'Fırın bölümleri']
    },
    {
      title: 'Diferansiyel Isı Dedektörleri',
      description: 'Hızlı sıcaklık artışını algılar. Normal sıcaklık değişimlerinden etkilenmez. Hassas algılama gerektirir.',
      applications: ['Laboratuvarlar', 'Temiz odalar', 'Arşiv alanları', 'Sunucu odaları']
    }
  ];

  const faqs = [
    {
      question: 'Yangın alarm sistemleri nasıl çalışır?',
      answer: 'Yangın alarm sistemleri, duman, ısı veya alev dedektörleri aracılığıyla yangın belirtilerini algılar ve alarm verir. Dedektörler, yangın alarm paneline bağlıdır ve sürekli olarak ortamı izler. Bir dedektör yangın belirtisi algıladığında, panel devreye girer, sesli ve ışıklı uyarı cihazları aktif olur, itfaiye ve yetkililere otomatik ihbar yapılır. Sistem, farklı bölgeler için ayrı ayrı yapılandırılabilir ve her bölgenin durumu panel üzerinden takip edilebilir.'
    },
    {
      question: 'Yangın alarm sistemi kurulumu zorunlu mudur?',
      answer: 'Evet, Türkiye\'de yangın alarm sistemi kurulumu birçok işletme türü için yasal zorunluluktur. Binaların Yangından Korunması Hakkında Yönetmelik\'e göre, fabrikalar, sanayi tesisleri, ofis binaları, alışveriş merkezleri ve belirli büyüklükteki işletmeler yangın alarm sistemi kurmak zorundadır. Sistem, TSE standartlarına uygun olmalı ve yetkili firmalar tarafından kurulmalıdır. Düzenli bakım ve test raporları tutulması da zorunludur.'
    },
    {
      question: 'Hangi dedektör türünü seçmeliyim?',
      answer: 'Dedektör seçimi, korunacak alanın özelliklerine göre yapılır. Ofis ve idari alanlarda optik duman dedektörleri, üretim hatlarında iyonizasyon dedektörleri, mutfak ve kazan dairelerinde sabit sıcaklık dedektörleri tercih edilir. Yüksek tavanlı alanlarda beam tipi dedektörler, açık alanlarda aspirasyon sistemleri kullanılır. Profesyonel keşif sonrası en uygun dedektör kombinasyonu belirlenir.'
    },
    {
      question: 'Yangın alarm sistemi ne kadar sürede kurulur?',
      answer: 'Kurulum süresi, binanın büyüklüğüne ve dedektör sayısına bağlıdır. Küçük ofisler için 1-2 gün, orta ölçekli fabrikalar için 3-5 gün, büyük sanayi tesisleri için 1-2 hafta sürebilir. Kurulum öncesi proje hazırlanır, itfaiye onayı alınır, kablo altyapısı döşenir, dedektörler ve uyarı cihazları monte edilir, sistem testleri yapılır ve TSE belgesi alınır.'
    },
    {
      question: 'Yangın alarm sistemi bakımı nasıl yapılır?',
      answer: 'Yangın alarm sistemleri yılda en az 2 kez periyodik bakıma tabi tutulmalıdır. Bakımda dedektörler test edilir, temizlenir, pil kontrolleri yapılır, panel yazılımı güncellenir ve sistem kalibrasyonu yapılır. Test sonuçları raporlanır ve itfaiye müdürlüğüne sunulur. Düzenli bakım, sistemin güvenilirliğini artırır ve yanlış alarm oranını azaltır. Bakım sözleşmelerimiz ile tüm bu işlemler profesyonelce gerçekleştirilir.'
    },
    {
      question: 'Hangi bölgelerde yangın alarm sistemleri kurulumu yapıyorsunuz?',
      answer: 'İstanbul Avrupa Yakası, İstanbul Anadolu Yakası, Ataşehir, Kadıköy, Ümraniye, Esenyurt, Başakşehir, Pendik, Kartal, Beylikdüzü, Tuzla, Gebze, Dilovası, Çayırova, Kocaeli, Sakarya, Yalova, Bursa, Tekirdağ ve Çorlu bölgelerinde yangın alarm sistemleri kurulumu hizmeti veriyoruz. Fabrika, sanayi tesisi, OSB ve kurumsal işletmelere TSE onaylı yangın alarm sistemleri kurulumu yapıyoruz.'
    }
  ];

  // Related Blog Posts Data
  const relatedBlogPosts = [
    {
      title: "Yangın Alarm Yönetmelikleri ve TSE Standartları",
      slug: "yangin-alarm-yonetmelikleri",
      description: "Türkiye'de yangın alarm sistemleri için geçerli yönetmelikler, TSE standartları ve zorunlu belgeler hakkında detaylı bilgiler.",
      category: "Güvenlik Sistemleri",
      readTime: "7 dakika"
    },
    {
      title: "Bina Yangın Alarm Sistemi Kurulum Projesi",
      slug: "bina-yangin-alarm-sistemi",
      description: "Çok katlı bina ve fabrika yapılarında yangın alarm sistemi nasıl kurulur? Dedektör seçimi, kablolama ve itfaiye onay süreçleri.",
      category: "Proje Deneyimleri", 
      readTime: "9 dakika"
    },
    {
      title: "IP Kamera Seçim Rehberi: Güvenlik Sistemleri Entegrasyonu",
      slug: "ip-kamera-secim-rehberi",
      description: "Yangın alarm sistemleri ile IP kamera entegrasyonu nasıl yapılır? Alarm tetiklendiğinde otomatik kayıt başlatma çözümleri.",
      category: "Güvenlik Sistemleri",
      readTime: "8 dakika"
    }
  ];

  return (
    <div className="min-h-screen bg-slate-950">
      <Navbar />
      <FloatingButtons />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/adc06c4bc8646b05553c69e7759841c7.jpg"
            alt="Yangın Alarm Sistemleri"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-slate-950/90 via-slate-950/85 to-slate-950"></div>
        </div>

        <div className="container mx-auto px-4 relative z-10">
          <nav className="flex items-center gap-2 text-sm text-gray-400 mb-8">
            <Link to="/" className="hover:text-red-400 transition-colors cursor-pointer">Ana Sayfa</Link>
            <i className="ri-arrow-right-s-line"></i>
            <Link to="/guvenlik-sistemleri" className="hover:text-red-400 transition-colors cursor-pointer">Güvenlik Sistemleri</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-red-400">Yangın Alarm Sistemleri</span>
          </nav>

          <div className="max-w-4xl">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-red-600/20 border border-red-500/30 rounded-full mb-6">
              <i className="ri-fire-line text-red-400 text-lg"></i>
              <span className="text-red-300 text-sm font-medium">TSE Onaylı Yangın Güvenliği</span>
            </div>

            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
              Yangın Alarm Sistemleri Kurulumu
            </h1>

            <p className="text-xl text-gray-300 mb-8 leading-relaxed">
              İstanbul, Kocaeli, Gebze, Tuzla, Bursa ve çevre illerde fabrika, sanayi tesisi ve kurumsal işletmeler için TSE ve CE onaylı yangın alarm sistemleri kurulumu. Duman dedektörleri, ısı sensörleri, sesli uyarı cihazları ve otomatik ihbar sistemi ile 7/24 yangın güvenliği.
            </p>

            <div className="flex flex-wrap items-center gap-4">
              <a
                href="tel:+905537165561"
                className="px-8 py-4 bg-gradient-to-r from-red-700 to-red-600 text-white rounded-lg font-semibold hover:shadow-lg hover:shadow-red-500/50 transition-all duration-300 hover:scale-105 flex items-center gap-2 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line text-xl"></i>
                Hemen Ara
              </a>
              <a
                href="https://wa.me/905537165561"
                target="_blank"
                rel="noopener noreferrer"
                className="px-8 py-4 bg-green-600 text-white rounded-lg font-semibold hover:shadow-lg hover:shadow-green-500/50 transition-all duration-300 hover:scale-105 flex items-center gap-2 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line text-xl"></i>
                WhatsApp Destek
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 bg-slate-900/30">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <article className="prose prose-invert prose-lg max-w-none">
              <h2 className="text-3xl font-bold text-white mb-6">Yangın Alarm Sistemleri Nedir?</h2>
              <p className="text-gray-300 leading-relaxed mb-6">
                Yangın alarm sistemleri, yangın belirtilerini erken aşamada algılayan ve uyarı veren hayat kurtarıcı güvenlik sistemleridir. Duman dedektörleri, ısı sensörleri ve alev dedektörleri gibi farklı algılama cihazları kullanarak, yangını başlangıç aşamasında tespit eder. Sistem devreye girdiğinde, yüksek desibel siren çalar, ışıklı uyarı cihazları aktif olur ve itfaiye ile yetkililere otomatik ihbar yapılır. Böylece can ve mal kaybı minimize edilir.
              </p>
              <p className="text-gray-300 leading-relaxed mb-8">
                Türkiye\'de Binaların Yangından Korunması Hakkında Yönetmelik gereği, fabrika, sanayi tesisi, ofis binası ve belirli büyüklükteki işletmelerde yangın alarm sistemleri kurulumu zorunludur. İstanbul, Kocaeli, Gebze, Tuzla, Bursa ve çevre illerde TSE onaylı yangın alarm sistemleri kurulumu hizmeti veriyoruz. Profesyonel ekibimiz, yönetmeliğe uygun proje hazırlama, kurulum ve TSE belgesi alma süreçlerini yönetir.
              </p>

              <h2 className="text-3xl font-bold text-white mb-6 mt-12">Yangın Alarm Sistemlerinin Bileşenleri</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8 not-prose">
                {features.map((feature, index) => (
                  <div key={index} className="bg-slate-800/50 border border-slate-700 rounded-xl p-6 hover:border-red-500/50 transition-all duration-300">
                    <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-red-700 to-red-600 rounded-lg mb-4">
                      <i className={`${feature.icon} text-2xl text-white`}></i>
                    </div>
                    <h3 className="text-xl font-bold text-white mb-2">{feature.title}</h3>
                    <p className="text-gray-400 text-sm">{feature.description}</p>
                  </div>
                ))}
              </div>

              <h2 className="text-3xl font-bold text-white mb-6 mt-12">Yangın Dedektörü Türleri</h2>
              <div className="space-y-6 mb-8 not-prose">
                {detectorTypes.map((detector, index) => (
                  <div key={index} className="bg-slate-800/50 border border-slate-700 rounded-xl p-6 hover:border-red-500/50 transition-all duration-300">
                    <h3 className="text-2xl font-bold text-white mb-3">{detector.title}</h3>
                    <p className="text-gray-300 leading-relaxed mb-4">{detector.description}</p>
                    <div className="flex flex-wrap gap-3">
                      {detector.applications.map((app, idx) => (
                        <span key={idx} className="px-3 py-1 bg-red-600/20 border border-red-500/30 rounded-full text-red-300 text-sm">
                          {app}
                        </span>
                      ))}
                    </div>
                  </div>
                ))}
              </div>

              <h2 className="text-3xl font-bold text-white mb-6 mt-12">Yangın Alarm Sistemi Kurulum Süreci</h2>
              <div className="space-y-6 mb-8 not-prose">
                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-gradient-to-br from-red-700 to-red-600 rounded-full text-white font-bold">1</div>
                  <div>
                    <h3 className="text-xl font-bold text-white mb-2">Proje Hazırlama</h3>
                    <p className="text-gray-300">Bina planları incelenir, risk analizi yapılır. Yönetmeliğe uygun yangın alarm projesi hazırlanır ve itfaiye müdürlüğüne sunulur.</p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-gradient-to-br from-red-700 to-red-600 rounded-full text-white font-bold">2</div>
                  <div>
                    <h3 className="text-xl font-bold text-white mb-2">İtfaiye Onayı</h3>
                    <p className="text-gray-300">Hazırlanan proje itfaiye müdürlüğüne sunulur ve onay alınır. Gerekli düzenlemeler yapılır.</p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-gradient-to-br from-red-700 to-red-600 rounded-full text-white font-bold">3</div>
                  <div>
                    <h3 className="text-xl font-bold text-white mb-2">Altyapı ve Montaj</h3>
                    <p className="text-gray-300">Kablo kanalları döşenir, yangın alarm kabloları çekilir. Dedektörler, uyarı cihazları ve butonlar monte edilir.</p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-gradient-to-br from-red-700 to-red-600 rounded-full text-white font-bold">4</div>
                  <div>
                    <h3 className="text-xl font-bold text-white mb-2">Panel Programlama</h3>
                    <p className="text-gray-300">Yangın alarm paneli programlanır, bölgeler tanımlanır, dedektörler adreslendirilir. Otomatik ihbar sistemi yapılandırılır.</p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-gradient-to-br from-red-700 to-red-600 rounded-full text-white font-bold">5</div>
                  <div>
                    <h3 className="text-xl font-bold text-white mb-2">Test ve Belgelendirme</h3>
                    <p className="text-gray-300">Tüm dedektörler test edilir, alarm senaryoları simüle edilir. İtfaiye kontrolü yapılır ve TSE belgesi alınır.</p>
                  </div>
                </div>
              </div>

              <h2 className="text-3xl font-bold text-white mb-6 mt-12">Adresli ve Konvansiyonel Sistemler</h2>
              <p className="text-gray-300 leading-relaxed mb-6">
                <strong className="text-white">Adresli Yangın Alarm Sistemleri:</strong> Her dedektörün benzersiz bir adresi vardır ve panel üzerinde hangi dedektörün alarm verdiği tam olarak görülür. Büyük tesislerde tercih edilir. Arıza tespiti kolaydır, bakım maliyetleri düşüktür. Loop yapısı ile kablo tasarrufu sağlar. Fabrika ve sanayi tesislerinde standart olarak adresli sistemler kullanılır.
              </p>
              <p className="text-gray-300 leading-relaxed mb-8">
                <strong className="text-white">Konvansiyonel Yangın Alarm Sistemleri:</strong> Dedektörler bölgeler halinde gruplandırılır. Alarm durumunda hangi bölgede yangın olduğu görülür ancak tam dedektör konumu belli olmaz. Küçük ve orta ölçekli işletmeler için uygun maliyetli çözümdür. Kurulum ve bakım basittir. Her iki sistem türü de TSE standartlarına uygundur ve güvenilir koruma sağlar.
              </p>

              <h2 className="text-3xl font-bold text-white mb-6 mt-12">Sanayi ve Fabrika Uygulamaları</h2>
              <p className="text-gray-300 leading-relaxed mb-6">
                Fabrika ve sanayi tesislerinde yangın alarm sistemleri kurulumu, özel dikkat ve uzmanlık gerektirir. Üretim hatlarında kullanılan kimyasallar, yüksek sıcaklık prosesleri, elektrik panoları ve depolama alanları farklı yangın riskleri taşır. Her alan için uygun dedektör türü seçilir ve hassasiyet ayarları optimize edilir. Yanlış alarm oranı minimize edilirken, gerçek yangın durumunda en hızlı tespit sağlanır.
              </p>
              <p className="text-gray-300 leading-relaxed mb-8">
                Yangın alarm sistemleri, sprinkler sistemleri, yangın söndürme sistemleri ve acil aydınlatma ile entegre çalışır. Alarm tetiklendiğinde, havalandırma sistemleri otomatik olarak durur, yangın kapıları kapanır ve tahliye yolları aydınlatılır. İstanbul, Kocaeli, Gebze, Tuzla ve Bursa bölgelerindeki sanayi tesislerine özel yangın güvenlik çözümleri sunuyoruz.
              </p>

              <h2 className="text-3xl font-bold text-white mb-6 mt-12">Yönetmelik ve Standartlar</h2>
              <p className="text-gray-300 leading-relaxed mb-6">
                Yangın alarm sistemleri, Binaların Yangından Korunması Hakkında Yönetmelik ve TSE standartlarına uygun olarak kurulmalıdır. TS EN 54 serisi standartları, yangın algılama ve alarm sistemlerinin tasarım, kurulum ve bakım gerekliliklerini belirler. Sistemde kullanılan tüm ekipmanlar TSE ve CE sertifikalı olmalıdır. Kurulum sonrası itfaiye kontrolü yapılır ve uygunluk belgesi alınır.
              </p>
              <p className="text-gray-300 leading-relaxed mb-8">
                Yangın alarm sistemleri, yılda en az iki kez periyodik bakıma tabi tutulmalı ve test raporları düzenlenmelidir. İşletme sorumluları, personele yangın alarm sistemi kullanımı ve acil durum prosedürleri hakkında eğitim vermelidir. Dedektörlerin temizliği, pil kontrolleri ve sistem testleri düzenli olarak yapılmalıdır. Profesyonel bakım sözleşmelerimiz ile tüm bu yükümlülükler yerine getirilir.
              </p>

              <h2 className="text-3xl font-bold text-white mb-6 mt-12">Otomatik İhbar ve Entegrasyonlar</h2>
              <p className="text-gray-300 leading-relaxed mb-6">
                Modern yangın alarm sistemleri, IP/GPRS modülleri ile itfaiye, güvenlik şirketi ve işletme yetkililerine otomatik ihbar yapar. Alarm tetiklendiğinde, hangi bölgede yangın olduğu, alarm zamanı ve dedektör bilgileri anında iletilir. Mobil uygulama üzerinden de alarm durumu takip edilebilir ve sistem yönetilebilir.
              </p>
              <p className="text-gray-300 leading-relaxed mb-8">
                Yangın alarm sistemleri, bina otomasyon sistemleri ile entegre çalışabilir. Alarm durumunda havalandırma sistemleri durdurulur, asansörler zemin kata iner, acil çıkış kapıları açılır ve acil aydınlatma devreye girer. Sprinkler sistemleri ile entegrasyon sayesinde, yangın algılandığında otomatik söndürme sistemi aktif olur. Tüm bu entegrasyonlar, yangın güvenliğini maksimum seviyeye çıkarır.
              </p>

              <h2 className="text-3xl font-bold text-white mb-6 mt-12">Bakım ve Periyodik Kontroller</h2>
              <p className="text-gray-300 leading-relaxed mb-6">
                Yangın alarm sistemleri, düzenli bakım ve periyodik kontroller ile güvenilirliğini korur. Yılda en az iki kez yapılması gereken bakımda, tüm dedektörler test edilir ve temizlenir. Duman dedektörleri, toz ve kir birikimi nedeniyle hassasiyetini kaybedebilir, bu nedenle düzenli temizlik kritiktir. Isı dedektörleri kalibre edilir, uyarı cihazları test edilir ve pil kontrolleri yapılır.
              </p>
              <p className="text-gray-300 leading-relaxed mb-8">
                Panel yazılımı güncellenir, olay kayıtları incelenir ve sistem optimizasyonu yapılır. Test sonuçları detaylı raporlanır ve itfaiye müdürlüğüne sunulur. Arızalı dedektör değişimi, panel bakımı ve sistem genişletme hizmetleri de sunuyoruz. İstanbul Avrupa Yakası, İstanbul Anadolu Yakası, Tuzla, Gebze, Kocaeli, Bursa ve diğer bölgelerde hızlı servis hizmeti veriyoruz. 7/24 teknik destek hattımız ile her türlü sorun anında çözülür.
              </p>
            </article>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-4xl font-bold text-white text-center mb-12">
              Sıkça Sorulan Sorular
            </h2>

            <div className="space-y-6">
              {faqs.map((faq, index) => (
                <details key={index} className="group bg-slate-900/50 border border-slate-800 rounded-xl overflow-hidden hover:border-red-500/50 transition-all duration-300">
                  <summary className="flex items-center justify-between p-6 cursor-pointer list-none">
                    <h3 className="text-xl font-bold text-white pr-4">{faq.question}</h3>
                    <i className="ri-arrow-down-s-line text-2xl text-red-400 group-open:rotate-180 transition-transform duration-300"></i>
                  </summary>
                  <div className="px-6 pb-6">
                    <p className="text-gray-300 leading-relaxed">{faq.answer}</p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Related Blog Posts */}
      <RelatedBlogPosts posts={relatedBlogPosts} />

      {/* Related Services */}
      <section className="py-20 bg-slate-900/30">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl font-bold text-white text-center mb-12">
              Diğer Güvenlik Sistemleri Hizmetlerimiz
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <Link to="/guvenlik-sistemleri/ip-kamera-sistemleri" className="group bg-slate-800/50 border border-slate-700 rounded-xl p-6 hover:border-red-500/50 transition-all duration-300 hover:-translate-y-1 cursor-pointer">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-red-600 to-orange-600 rounded-lg mb-4 group-hover:scale-110 transition-transform">
                  <i className="ri-camera-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-2 group-hover:text-red-400 transition-colors">IP Kamera Sistemleri</h3>
                <p className="text-gray-400 text-sm">4K Ultra HD kamera kurulumu ve izleme</p>
              </Link>

              <Link to="/guvenlik-sistemleri/hirsiz-alarm-sistemleri" className="group bg-slate-800/50 border border-slate-700 rounded-xl p-6 hover:border-orange-500/50 transition-all duration-300 hover:-translate-y-1 cursor-pointer">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-orange-600 to-amber-600 rounded-lg mb-4 group-hover:scale-110 transition-transform">
                  <i className="ri-alarm-warning-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-2 group-hover:text-orange-400 transition-colors">Hırsız Alarm Sistemleri</h3>
                <p className="text-gray-400 text-sm">Kablosuz ve kablolu alarm sistemleri</p>
              </Link>

              <Link to="/guvenlik-sistemleri/gecis-kontrol-sistemleri" className="group bg-slate-800/50 border border-slate-700 rounded-xl p-6 hover:border-cyan-500/50 transition-all duration-300 hover:-translate-y-1 cursor-pointer">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-blue-600 to-cyan-600 rounded-lg mb-4 group-hover:scale-110 transition-transform">
                  <i className="ri-door-lock-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-2 group-hover:text-cyan-400 transition-colors">Geçiş Kontrol Sistemleri</h3>
                <p className="text-gray-400 text-sm">Kartlı ve biyometrik geçiş sistemleri</p>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-red-700/20 to-red-600/20"></div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl font-bold text-white mb-6">
              Yangın Alarm Sistemi Kurulumu İçin Hemen İletişime Geçin
            </h2>
            <p className="text-xl text-gray-300 mb-8">
              TSE onaylı yangın alarm sistemleri için ücretsiz keşif ve teknik danışmanlık hizmeti alın.
            </p>
            <div className="flex flex-wrap items-center justify-center gap-4">
              <a
                href="tel:+905537165561"
                className="px-8 py-4 bg-gradient-to-r from-red-700 to-red-600 text-white rounded-lg font-semibold hover:shadow-lg hover:shadow-red-500/50 transition-all duration-300 hover:scale-105 flex items-center gap-2 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line text-xl"></i>
                +90 553 716 55 61
              </a>
              <a
                href="https://wa.me/905537165561"
                target="_blank"
                rel="noopener noreferrer"
                className="px-8 py-4 bg-green-600 text-white rounded-lg font-semibold hover:shadow-lg hover:shadow-green-500/50 transition-all duration-300 hover:scale-105 flex items-center gap-2 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line text-xl"></i>
                WhatsApp
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />

      {/* Schema Markup */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": faqs.map(faq => ({
            "@type": "Question",
            "name": faq.question,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": faq.answer
            }
          }))
        })}
      </script>
    </div>
  );
}
